import React, { useState } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core'
import swal from 'sweetalert'
import NumberFormat from 'react-number-format'
import { updateAdaptationMeasures } from '../../../../../services/Elegibilidad/put'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'

export const Modal52Edit = ({ open, setOpen, getDataTable, body, setBody }) => {
  const {
    IdAdaptationMeasure,
    IdElegibilityAnswer,
    IdTechnology,
    TechnologyDetail,
    IsImplemented,
    Justification,
    IsRequired,
    LandAreaToImprove,
    agriculturistNumber,
    isDefault,
  } = body

  const [errorJustification, setErrorJustification] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    TechnologyDetail: Yup.string().required('Este campo es obligatorio'),
    IsImplemented: Yup.boolean()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    Justification: Yup.string()
      .max(100, 'Max 100 caracteres')
      .matches(
        /^[-:;.,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .required('Este campo es obligatorio')

      // .when('IsImplemented', {
      //   is: true,
      //   then:
      // Yup.string()
      //    .required('Este campo es obligatorio')
      //    .typeError('Viene null'),
      // // })
      .typeError('Este campo es obligatorio'),
    IsRequired: Yup.boolean()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio'),
    // .when('IsImplemented', {
    //   is: true,
    //   then: Yup.boolean().required('Este campo es obligatorio'),
    // }),
    LandAreaToImprove: Yup.number()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio'),
    // .when('IsImplemented', {
    //   is: true,
    //   then: Yup.number()
    //     .required('Este campo es obligatorio')
    //     .typeError('Este campo es obligatorio'),
    // }),

    agriculturistNumber: Yup.number()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio'),
    // .when('IsImplemented', {
    //   is: true,
    //   then: Yup.number()
    //     .required('Este campo es obligatorio')
    //     .typeError('Este campo es obligatorio'),
    // }),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdAdaptationMeasure: IdAdaptationMeasure,
      IdElegibilityAnswer: IdElegibilityAnswer,
      IdTechnology: IdTechnology,
      TechnologyDetail: TechnologyDetail,
      IsImplemented: IsImplemented,
      Justification: Justification,
      IsRequired: IsRequired,
      LandAreaToImprove: LandAreaToImprove,
      agriculturistNumber: agriculturistNumber,
      isDefault: isDefault,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      handleGuardar(values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleGuardar = async (values) => {
    const response = await updateAdaptationMeasures(values)
    if (response.Success) {
      swal({
        title: '¡Datos actualizados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      handleClose()
    }
  }

  const handleClose = () => {
    setOpen(false)
    setBody({})
    formik.resetForm()
    setErrorJustification(false)
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos de la medida de adaptación</h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Tecnología de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="tecAdaptacion"
                    name="tecAdaptacion"
                    type="text"
                    variant="outlined"
                    sx={{ width: 220 }}
                    onChange={(e) => {
                      formik.setFieldValue('TechnologyDetail', e.target.value)
                    }}
                    value={formik.values.TechnologyDetail}
                    error={formik.errors.TechnologyDetail}
                    disabled
                  />
                  {formik.errors.TechnologyDetail ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.TechnologyDetail}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6}>
                    <label className="responsiveLabel">
                      ¿Está implementado actualmente?
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} justifyContent="left">
                    <FormControl fullWidth>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={formik.values.IsImplemented}
                        name="radio-buttons-group"
                        row
                        onChange={(e) => {
                          if (e.target.value === 'true') {
                            formik.setFieldValue('IsImplemented', true)
                          } else {
                            formik.setFieldValue('IsImplemented', false)
                            // formik.setValues({
                            //   ...formik.values,
                            //   IsImplemented: false,
                            //   Justification: '',
                            //   IsRequired: '',
                            //   LandAreaToImprove: 0,
                            //   agriculturistNumber: 0,
                            // })
                          }
                        }}
                        error={formik.errors.IsImplemented}
                      >
                        <FormControlLabel
                          value={true}
                          control={<Radio />}
                          label="Si"
                        />
                        <FormControlLabel
                          value={false}
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                      {formik.errors.IsImplemented ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.IsImplemented}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Justificación</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, diagonal, comillas."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Justificación"
                    customInput={TextField}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-:.;,#()/"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorJustification(false)
                        formik.setFieldValue('Justification', e.target.value)
                      } else {
                        setErrorJustification(true)
                      }
                    }}
                    value={formik.values.Justification}
                    maxLength={100}
                    error={formik.errors.Justification}
                    // disabled={!formik.values.IsImplemented}
                  ></textarea>
                  {errorJustification ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.Justification ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.Justification}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={6} md={6}>
                      <label className="responsiveLabel">
                        ¿Requerido como parte del subproyecto?
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                        // disabled={!formik.values.IsImplemented}
                      >
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={formik.values.IsRequired}
                          name="radio-buttons-group"
                          row
                          onChange={(e) => {
                            if (e.target.value === 'true') {
                              formik.setFieldValue('IsRequired', true)
                            } else {
                              formik.setFieldValue('IsRequired', false)
                            }
                          }}
                          error={formik.errors.IsRequired}
                        >
                          <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label="Si"
                          />
                          <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                        {formik.errors.IsRequired ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.IsRequired}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Área de tierra a mejorar con la medida de adaptación
                        (Ha)
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareas"
                          allowLeadingZeros={false}
                          name="cantHectareas"
                          customInput={TextField}
                          thousandSeparator={true}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          inputProps={{ maxLength: 8 }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'LandAreaToImprove',
                              parseFloat(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          value={formik.values.LandAreaToImprove}
                          error={formik.errors.LandAreaToImprove}
                          decimalScale={2}
                          // disabled={!formik.values.IsImplemented}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Número de Empleados que se espera que adopten la medida
                        de adaptación
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="cantHectareasSubproyecto"
                          name="cantHectareasSubproyecto"
                          allowLeadingZeros={false}
                          customInput={TextField}
                          thousandSeparator={true}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          inputProps={{ maxLength: 3 }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'agriculturistNumber',
                              parseInt(e.target.value),
                            )
                          }}
                          value={formik.values.agriculturistNumber}
                          decimalScale={0}
                          error={formik.errors.agriculturistNumber}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} sm={6} md={6}>
                  {formik.errors.LandAreaToImprove ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.LandAreaToImprove}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  {formik.errors.agriculturistNumber ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.agriculturistNumber}
                    </div>
                  ) : null}
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
